import _ from 'lodash';
import { URGENT_NOTIFICATION } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * UrgentNotification Reducer
 * @param {*} state
 * @param {*} action
 */
export default function urgentNotification(state = initialState, action = {}) {
  switch (action.type) {
    case `${URGENT_NOTIFICATION}_PENDING`:
      return {
        ...state,
        error: null, // state.error = null
        loaded: false, // state.loaded = false
        loading: true, // state.loading = true
      };
    case `${URGENT_NOTIFICATION}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        result: action?.result,
        loading: false,
      };
    case `${URGENT_NOTIFICATION}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
